import type { Dashboard } from "@/types/dashboard"
import { HttpClient, HUB_ROOT } from "@/api/httpClient"

export default {
	getDashboard() {
		return HttpClient.get<Dashboard>(`${HUB_ROOT}/users/dashboard`)
	}
}
